<template>
  <div>
    <div class="verification-info">
      {{ i18n.t("discount.voucher.verification.info") }}
    </div>
    <div class="flex-container">
      <form ref="verificationForm" class="verification-form" v-on:submit.prevent="onSubmit">
        <div class="inputs-wrapper">
          <div class="form-group">
            <label for="isicNumber">
              {{ i18n.t("discount.voucher.verification.fields.isicNumber") }}&nbsp;*
            </label>
            <input id="isicNumber" v-model="values.isicNumber" class="form-input"
                type="text" @change="onIsicNumberChange" required />
          </div>
          <div class="form-group">
            <label for="cardholderName">
              {{ i18n.t("discount.voucher.verification.fields.cardholderName") }}&nbsp;*
            </label>
            <input id="cardholderName" v-model="values.cardholderName" class="form-input"
                type="text" @change="onCardholderNameChange" required />
          </div>
        </div>
        <div class="dialog-buttons">
          <button type="submit" class="primary-button submit-button">
            {{ i18n.t("discount.voucher.verification.submit") }}
          </button>
        </div>
      </form>
      <isic-hint image-class="number-hint"></isic-hint>
    </div>
    <div class="order-info">
      {{ i18n.t("discount.voucher.verification.orderInfo.text") }}
      <a class="order-link" href="https://www.isic.org/get-your-card/">
        {{ i18n.t("discount.voucher.verification.orderInfo.link") }}
      </a>
    </div>
  </div>
</template>

<style scoped>
  @import '../../../assets/css/button-style.css';

  .flex-container {
    display: flex;
    justify-content: space-between;
  }
  .verification-form {
    width: 50%;
    padding-top: 4px;
    margin-top: 4px;
  }
  .form-input {
    width: 90%;
    border-radius: 4px;
    border: var(--primary-color) solid 2px;
    margin-top: 8px;
    margin-bottom: 16px;
    height: 40px;
  }
  label {
    font-weight: bold;
    margin-bottom: 4px;
  }
  .verification-info {
    margin-bottom: 16px;
  }
  .number-hint {
    width: 50%;
    height: 215px;
    margin-top: 2px;
  }
  .order-info {
    margin-top: 16px;
    width: 100%;
  }
  .order-link {
    font-weight: bold;
    color: #006666;
  }
  .submit-button {
    width: 90%;
    min-height: 40px;
    font-weight: bold;
  }
  @media screen and (max-width: 700px) {
    .flex-container {
      flex-direction: column-reverse;
    }
    .form-input {
      width: 100%;
    }
    .primary-button.submit-button {
      width: 100%;
    }
    .verification-form {
      width: 100%;
    }
    .number-hint {
      width: 100%;
      height: auto;
    }
  }
</style>

<script>
import i18nProvider from '@/lang/i18nProvider';
import { mapActions } from 'vuex';
import IsicHint from '../IsicHint.vue';

export default {
  name: 'verification-step',
  props: {
    defaultValues: {
      type: Object,
      required: false,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      default: (() => {}),
    },
    onInputChange: {
      type: Function,
      required: true,
    },
    isRedirectVoucher: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  created() {
    Object.assign(this.values, this.defaultValues);
  },
  computed: {
    i18n() {
      return i18nProvider;
    },
  },
  methods: {
    onSubmit() {
      this.verifyUser({
        isicNumber: this.values.isicNumber,
        cardholderName: this.values.cardholderName,
        verificationType: 'CARD_INFO',
        isRedirectVoucher: this.isRedirectVoucher,
      });
    },
    onIsicNumberChange(e) {
      this.onInputChange('isicNumber', e.target.value);
    },
    onCardholderNameChange(e) {
      this.onInputChange('cardholderName', e.target.value);
    },
    ...mapActions({
      verifyUser: 'verifyUser',
    }),
  },
  data() {
    return {
      values: {
        isicNumber: null,
        cardholderName: null,
      },
    };
  },
  components: {
    IsicHint,
  },
};
</script>
